import { render, staticRenderFns } from "./EmptyResults.vue?vue&type=template&id=768c19d9"
import script from "./EmptyResults.vue?vue&type=script&lang=js"
export * from "./EmptyResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports